import { render, staticRenderFns } from "./GuestsView.vue?vue&type=template&id=12267b0e"
import script from "./GuestsView.vue?vue&type=script&lang=js"
export * from "./GuestsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports